'use strict';

/* General Libs */
import 'expose-loader?tv4!tv4';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import '../../components/angular-schema-form-file-upload/schema-form-file';

import 'pickadate/lib/picker';
import 'pickadate/lib/themes/classic.css';
import 'pickadate/lib/themes/classic.date.css';
import 'pickadate/lib/themes/classic.time.css';

import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

import 'angular-schema-form-datepicker/bootstrap-datepicker.min';

/* Views */
import EFormList from './list/e-form-list.component';
import EFormEditor from './edit/e-form-editor.component';
import EForm from './form/e-form.component';
import EFormBrowser from './browser/e-form-browser.component';

/* Services */
import EFormsService from '../../components/eforms/eforms.service';
import EFormResultsService from '../../components/eform-results/eform-results.service';

export default angular.module('conduu.eForms', ['schemaForm', 'ngSchemaFormFile', EFormList, EForm, EFormBrowser, EFormEditor,
  EFormResultsService, EFormsService])
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/index.js